import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import { StyledDiv} from "./Login.styled";
import {LoginCard} from "../../components";
import style from "../../components/loginCard/LoginCard.module.scss";

const LoginPage = () => {
    useEffect(() => {
        localStorage.removeItem('jwt')
    }, []);
    return (
        <StyledDiv>
            <LoginCard/>
        </StyledDiv>
    );
};

export default connect(null, {})(withRouter(LoginPage));
